import { COLORS } from '@avalara/bat-apps-shared/constants';
import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';

import styled from 'styled-components';

import { content } from './content';
import TrialTile from './trial-tile';

const GetTheMostHeading = styled.h1`
  color: ${COLORS.grayBlack};
  line-height: 38px;
  font-size: 30px;
`;

const Resources = () => (
  <div className='pad-left-sm pad-right-sm'>
    <SRow>
      <SCol span='12' center='' className='pad-top-lg pad-bottom-none'>
        <GetTheMostHeading className='text-center'>{t('client.headings.get-the-most-from-avatax')}</GetTheMostHeading>
      </SCol>
    </SRow>
    <SRow className='justify-content-center'>
      {content.map(({ title, textContent, buttonText, link }) => (
        <TrialTile title={title} textContent={textContent} buttonText={buttonText} link={link} key={title} />
      ))}
    </SRow>
  </div>
);
export default Resources;
